import React, { Component } from 'react'
import { Card } from 'react-bootstrap';

import '../Styles.css';

class ComprobanteConceptoInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card className="mb-2">
        <Card.Body>

          <span className="text-muted">
            <strong>{ data.clave_prod_serv }</strong>
          </span>
          <br/>

          <strong>
            <span className="text-muted">{ data.cantidad }</span> - { data.descripcion }
          </strong>
          <br/>

          <strong className="text-black card-label-info">Unidad: </strong>
          { data.clave_unidad } { data.unidad ? ` - ${data.unidad}` : ''}
          <br/>

          { !!data.no_identificacion && (
              <>
                <strong className="text-black card-label-info">SKU: </strong>
                  { data.no_identificacion }
                <br/>
              </>
            )
          }

          { !!data.descuento && (
              <span>
                <strong className="text-black card-label-info">Descuento: </strong>
                  { data.descuento }
                <br/>
              </span>
            )
          }

          <strong className="text-black card-label-info">Importe: </strong>
          { data.importe }
          <br/>
        </Card.Body>
      </Card>
    )
  }
}

export default ComprobanteConceptoInfo;